module.exports = __webpack_public_path__ + "img/Maneki Street_redeem.96d84a5e.png";